import React, { useEffect, useRef } from "react";
import { GeneralTable, useModalAlert } from "../GeneralComponents";
import moment from "moment";
import { makeStyles } from "@material-ui/core/styles";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import { SubirDocument } from "./SubirDocument";
import PictureAsPdfIcon from "@material-ui/icons/PictureAsPdf";
import { IconButton, Modal } from "@material-ui/core";
import CloseIcon from "mdi-react/CloseIcon";
import PrintIcon from "@material-ui/icons/Print";
import JsBarcode from "jsbarcode";
import { useReactToPrint } from "react-to-print";

const pageStyle = `
  @page {
    size: 100mm 25mm;
    margin: 0;
  }
  @media print {
    body {
      -webkit-print-color-adjust: exact;
    }
    .print-container {
      width: 100mm !important;
      height: 25mm !important;
      margin: 0mm !important;
      padding: 0mm !important;
      overflow: hidden;
    }
  }
`;

const useStyles = makeStyles({
  centeredCell: {
    display: "flex",
    alignItems: "center",
    whiteSpace: "pre-wrap",
    overflow: "hidden", // Hides overflow if it's on one line
    textOverflow: "ellipsis", // Adds '...' if the text is truncated
    lineHeight: "normal", // Ensure standard line height
  },
});

export function TabletExternalDocumentation() {
  const classes = useStyles();
  const [radicacionSeleccionada, setRadicacionSeleccionada] =
    React.useState(null);
  const [radicaciones, setRadicaciones] = React.useState([]);
  const [listTypesDocumentales, setListTypesDocumentales] = React.useState([]);
  const [listOffice, setListOffice] = React.useState([]);
  const [listUsers, setListUsers] = React.useState([]);
  const [listUsersCopiaDep, setListUsersCopiaDep] = React.useState([]);
  const [listCountries, setListCountries] = React.useState([]);
  const [listDepartments, setListDepartments] = React.useState([]);
  const [listCities, setListCities] = React.useState([]);
  const [formData, setFormData] = React.useState({
    id_pais: 38,
    id_dep: 26,
  });
  const [listTipoDocumentos, setListTipoDocumentos] = React.useState([]);
  const [listTipoDocumentalOriginales, setListTipoDocumentalOriginales] =
    React.useState([]);
  const [openModalSubir, setopenModalSubir] = React.useState(null);
  const { showModalAlert } = useModalAlert();
  const pais = formData.id_pais;
  const id_dep = formData.id_dep;
  const dependencia = formData.id_gd_dependencia_resp;
  const dependenciaCopia = formData.copia_dependencia;
  const tipoDocumental = formData.id_gd_tipo_documental;
  const [documentoSeleccionado, setDocumentoSeleccionado] =
    React.useState(null);
  const [showPdf, setShowPdf] = React.useState(false);
  const [idDocumentoRad, setIdDocumentoRad] = React.useState(null);
  const [page, setPage] = React.useState(0);
  const [pageSize, setPageSize] = React.useState(5);
  const [rowCount, setRowCount] = React.useState(0);
  const [listTipoRadicado, setListTipoRadicado] = React.useState([]);
  const [numeroRadicado, setNumeroRadicado] = React.useState(null); // Estado para el número
  const [fechaRadicado, setFechaRadicado] = React.useState(null);
  const [userResponsable, setUserResponsable] = React.useState(null);
  const [folios, setFolios] = React.useState(null);
  const [anexos, setAnexos] = React.useState(null);
  const [dependenciaRes, setDependenciaRes] = React.useState(null);
  const [remitente, setRemitente] = React.useState(null);
  const barcodeRef = useRef(null);
  const labelPrintRef = useRef(null);
  const [numIdentificacion, setNumIdentificacion] = React.useState(null);
  const [dates, setDates] = React.useState({
    start: new Date(),
    end: new Date(),
  });

  useEffect(() => {
    loadTipoDocumentales();
    loadProductionOffice();
    loadCountries();
    loadTiposDocumentos();
    loadTipoRadicado();
  }, []);

  useEffect(() => {
    if (numeroRadicado && barcodeRef.current) {
      JsBarcode(barcodeRef.current, numeroRadicado, {
        format: "CODE128",
        lineColor: "#000",
        width: 1.5,
        height: 35,
        fontSize: 15,
        displayValue: true,
      });
    }
  }, [numeroRadicado]);

  useEffect(() => {
    loadRadicaciones();
  }, [page, pageSize, dates, setDates]);

  useEffect(() => {
    if (
      formData &&
      !!formData.numero_identificacion &&
      formData.numero_identificacion !== numIdentificacion
    ) {
      setNumIdentificacion(formData.numero_identificacion);
      loadRemitente(formData.numero_identificacion);
    }
  }, [formData]);

  useEffect(() => {
    if (pais) {
      loadDepartments();
    }
  }, [pais]);

  useEffect(() => {
    if (id_dep) {
      loadCities();
    }
  }, [id_dep]);

  useEffect(() => {
    if (dependencia) {
      loadUsers();
    }
  }, [dependencia]);

  useEffect(() => {
    if (dependenciaCopia) {
      loadUsersDep();
    }
  }, [dependenciaCopia]);

  useEffect(() => {
    if (tipoDocumental) {
      const encontradoTD = listTipoDocumentalOriginales.find((elemTD) => {
        return elemTD.id_gd_tipo_documental == tipoDocumental;
      });

      setFormData((prev) => {
        return {
          ...prev,
          dias_restante: encontradoTD.tiempo_tramite,
        };
      });
    }
  }, [tipoDocumental]);

  const handleCloseModal = () => {
    setopenModalSubir(false);
  };

  const handlePrint = useReactToPrint({
    contentRef: labelPrintRef,
    pageStyle: pageStyle,
  });

  const handlePageChange = (pageNumber) => {
    setPage(pageNumber);
  };

  const handlePageSizeChange = (pageSize) => {
    setPageSize(pageSize);
  };

  const handleOpenModal = (row) => {
    setopenModalSubir(true);
    setDocumentoSeleccionado(row);
    setNumIdentificacion(null);
  };

  const loadRadicaciones = async () => {
    const startDate = dates.start
      ? moment(dates.start).format("YYYY-MM-DD")
      : "";
    const endDate = dates.end ? moment(dates.end).format("YYYY-MM-DD") : "";
    const params = new URLSearchParams({
      page: page + 1,
      page_size: pageSize,
      start_date: startDate,
      end_date: endDate,
    }).toString();

    await fetch(
      process.env.REACT_APP_PUBLIC_URL + `radicacion/listar?${params}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      },
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        const dataRows = data.results.map((row) => ({
          ...row,
          id: row.id_gd_radicacion,
        }));
        setRadicaciones(dataRows);
        setRowCount(data.count);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const loadRemitente = async (numero_identificacion) => {
    await fetch(
      process.env.REACT_APP_PUBLIC_URL +
        `remitente-gd/listar?numero_identificacion=${numero_identificacion}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      },
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log("datos del remitente", data);
        if (data.length > 0) {
          setRemitente(data[0]?.nombre);
          setFormData((prev) => ({
            ...prev,
            nombre: data[0]?.nombre,
            tipo_remitente: data[0]?.tipo_remitente,
            direccion: data[0]?.direccion,
            telefono_fijo: data[0]?.telefono_fijo,
            celular: data[0]?.celular,
            email: data[0]?.email,
            id_pais: data[0]?.id_pais,
            id_dep: data[0]?.id_dep,
            id_ciudad: data[0]?.id_ciudad,
          }));
        } else {
          setRemitente(null);
          setFormData((prev) => ({
            ...prev,
            nombre: "",
            tipo_remitente: "",
            direccion: "",
            telefono_fijo: "",
            celular: "",
            email: "",
            id_ciudad: "",
          }));
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const loadDocumentosRadicados = async (idRadicacion) => {
    return await fetch(
      process.env.REACT_APP_PUBLIC_URL +
        "documento-radicados/listar?idRadicacion=" +
        idRadicacion,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      },
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        return data[0].id_gd_documentos_radicados;
      })
      .catch((error) => {
        console.error("Error:", error);
        return null;
      });
  };

  const loadTipoDocumentales = async () => {
    await fetch(
      process.env.REACT_APP_PUBLIC_URL + "tipo-documental/listar?estado=A",
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      },
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log("data.results", data.results);

        setListTipoDocumentalOriginales(data.results);
        const listatipoDocumental = data.results.map((tipoDocumental) => {
          return {
            value: tipoDocumental.id_gd_tipo_documental,
            label: tipoDocumental.descripcion,
          };
        });
        setListTypesDocumentales(listatipoDocumental);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const loadProductionOffice = async () => {
    await fetch(
      process.env.REACT_APP_PUBLIC_URL + "dependencia/listar?estado=A",
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      },
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        const listaDependencias = data.results.map((unidad) => {
          return {
            value: unidad.id_gd_dependencia,
            label: unidad.descripcion,
          };
        });
        setListOffice(listaDependencias);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const loadCountries = async () => {
    await fetch(process.env.REACT_APP_PUBLIC_URL + "paises/listar", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + sessionStorage.getItem("token"),
      },
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        const listCountries = data.map((pais) => {
          return {
            value: pais.id,
            label: pais.painom,
          };
        });
        setListCountries(listCountries);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const loadTiposDocumentos = async () => {
    await fetch(
      process.env.REACT_APP_PUBLIC_URL + "tipo-documento/listar?estado=A",
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      },
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        const listaTipoDocumento = data.map((tipoDoc) => {
          return {
            value: tipoDoc.id_gd_tipo_documento,
            label: tipoDoc.nombre,
          };
        });
        setListTipoDocumentos(listaTipoDocumento);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const loadDepartments = async () => {
    await fetch(process.env.REACT_APP_PUBLIC_URL + "departamentos/listar", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + sessionStorage.getItem("token"),
      },
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        const listDepartments = data.map((departamento) => {
          return {
            value: departamento.id,
            label: departamento.depnom,
          };
        });
        setListDepartments(listDepartments);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const loadCities = async () => {
    var data = { id_dep: id_dep };
    await fetch(process.env.REACT_APP_PUBLIC_URL + "ciudades/listar", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + sessionStorage.getItem("token"),
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log("ciudades", data);
        const listCities = data.map((city) => {
          return {
            value: city.id,
            label: city.ciunom,
          };
        });
        setListCities(listCities);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const loadUsers = async () => {
    try {
      const dataToSend = { id_gd_dependencia: dependencia };
      const response = await fetch(
        `${process.env.REACT_APP_PUBLIC_URL}usuario/listarDependeciaResponsable`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
          body: JSON.stringify(dataToSend),
        },
      );

      const result = await response.json();

      const listaUser = result.map((user) => ({
        value: user.id_usuario,
        label: user.nombre_usuario,
      }));

      setListUsers(listaUser);
    } catch (error) {
      console.error("Error al cargar usuarios:", error);
    }
  };

  const loadUsersDep = async () => {
    const data = { id_gd_dependencia_copia: dependenciaCopia };
    await fetch(process.env.REACT_APP_PUBLIC_URL + "usuario/listarCopiaDep", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + sessionStorage.getItem("token"),
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        const listaUser = data.map((user) => ({
          value: user.id_usuario,
          label: user.nombre_usuario,
        }));
        setListUsersCopiaDep(listaUser);
      })
      .catch((error) => {
        console.error("Error:", error);
        setListUsersCopiaDep([]);
      });
  };

  const loadTipoRadicado = async () => {
    await fetch(process.env.REACT_APP_PUBLIC_URL + "tipo-radicado/listar", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + sessionStorage.getItem("token"),
      },
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        const listaTipoRadicado = data.map((tr) => {
          return {
            value: tr.id_gd_tipo_radicado,
            label: tr.nombre,
          };
        });
        setListTipoRadicado(listaTipoRadicado);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const columns = [
    {
      field: "fecha_radicacion",
      headerName: "FECHA Y HORA",
      type: "date",
      flex: 1,
      disableColumnMenu: true,
      sortable: false,
      valueFormatter: (params) =>
        params.value ? moment(params.value).format("DD/MM/YYYY HH:mm:ss") : "",
    },
    {
      field: "numero_radicado",
      headerName: "# DE RADICADO",
      flex: 1,
      disableColumnMenu: true,
      sortable: false,
    },
    {
      field: "asunto",
      headerName: "ASUNTO",
      type: "string",
      flex: 1.5,
      disableColumnMenu: true,
      sortable: false,
      renderCell: (params) => (
        <div className={classes.centeredCell} style={{ width: "100%" }}>
          {params.value}
        </div>
      ),
    },
    {
      field: "nombre_remitente",
      headerName: "REMITENTE",
      type: "string",
      flex: 1.3,
      disableColumnMenu: true,
      sortable: false,
      renderCell: (params) => (
        <div className={classes.centeredCell} style={{ width: "100%" }}>
          {params.value}
        </div>
      ),
    },
    {
      field: "nombre_dependencia",
      headerName: "DEPENDENCIA RESPONSABLE",
      type: "string",
      flex: 1.5,
      disableColumnMenu: true,
      sortable: false,
      renderCell: (params) => (
        <div className={classes.centeredCell} style={{ width: "100%" }}>
          {params.value}
        </div>
      ),
    },
    {
      field: "nombre_usuario",
      headerName: "USUARIO RESPONSABLE",
      type: "string",
      flex: 1.3,
      disableColumnMenu: true,
      sortable: false,
    },
  ];

  const newModalField = [
    {
      type: "label",
      label: "Datos del remitente",
    },
    {
      name: "id_gd_tipo_documento",
      label: "Tipo de documento",
      type: "select",
      options: listTipoDocumentos,
    },
    {
      name: "numero_identificacion",
      label: "Número de documento",
      type: "mayuscula",
    },
    {
      name: "nombre",
      label: "Nombre completo/Razón Social",
      type: "mayuscula",
    },
    {
      name: "tipo_remitente",
      label: "Tipo de remitente/destinatario",
      type: "select",
      options: [
        { value: "natural", label: "Persona natural" },
        { value: "juridica", label: "Persona jurídica" },
      ],
    },
    {
      name: "direccion",
      label: "Dirección",
      type: "mayuscula",
    },
    {
      name: "telefono_fijo",
      label: "Teléfono fijo",
      type: "number",
    },
    {
      name: "celular",
      label: "Celular",
      type: "number",
    },
    {
      name: "email",
      label: "Correo electrónico",
      type: "email",
    },
    {
      name: "id_pais",
      label: "País",
      type: "select",
      options: listCountries,
    },
    {
      name: "id_dep",
      label: "Departamento",
      type: "select",
      options: listDepartments,
    },
    {
      name: "id_ciudad",
      label: "Municipio",
      type: "select",
      options: listCities,
    },
    {
      type: "label",
      label: "Datos del documento",
    },
    {
      name: "id_gd_tipo_radicado",
      label: "Tipo radicado",
      type: "select",
      options: listTipoRadicado,
    },
    {
      name: "asunto",
      label: "Asunto",
      type: "textarea",
    },
    {
      name: "numero_anexos",
      label: "Número de anexos",
      type: "number",
    },
    {
      name: "numero_folios",
      label: "Número de folios",
      type: "number",
    },
    {
      name: "medio_envio",
      label: "Medio de envio",
      type: "select",
      options: [
        { value: "mensajeria", label: "Mensajeria" },
        { value: "telefono", label: "Teléfono" },
        { value: "email", label: "Correo electrónico" },
        { value: "personal", label: "Personal" },
        { value: "pagina_web", label: "Página web" },
      ],
    },
    {
      name: "id_gd_tipo_documental",
      label: "Tipos Documentales",
      type: "select",
      options: listTypesDocumentales,
    },
    {
      name: "dias_restante",
      label: "Días de término",
      type: "number",
    },
    {
      name: "isconfidencialrad",
      label: "Marcar como confidencial el radicado",
      type: "checkbox-boolean",
    },
    {
      name: "autorizacion_correo",
      label: "Usted autoriza recibir respuesta por medio de correo electrónico",
      type: "checkbox-boolean",
    },
    {
      name: "id_gd_dependencia_resp",
      label: "Dependencia responsable",
      type: "select",
      options: listOffice,
    },
    {
      name: "id_usuario_resp",
      label: "Usuario responsable",
      type: "select",
      options: listUsers,
    },
    {
      name: "copia_dependencia",
      label: "Copia a la Dependencia",
      type: "optionalField",
      options: listOffice,
    },
    {
      name: "copia_usuario",
      label: "Copia al Usuario",
      type: "optionalField",
      options: listUsersCopiaDep,
    },
  ];

  const requiredFields = [
    "id_gd_tipo_documento",
    "numero_identificacion",
    "nombre",
    "tipo_remitente",
    "direccion",
    "telefono_fijo",
    "celular",
    "email",
    "id_pais",
    "id_dep",
    "id_ciudad",
    "asunto",
    "id_gd_tipo_radicado",
    //"num_anexos",
    //"num_folios",
    "medio_envio",
    "id_gd_tipo_documental",
    "id_gd_dependencia_resp",
    "id_usuario_resp",
  ];

  async function handleSaveRadication(formData) {
    const copia_dependencia = (formData.copia_dependencia || []).reduce(
      (acc, id) => {
        const copiaDependencia = listOffice.find((item) => item.value === id);
        if (copiaDependencia) {
          acc[id] = copiaDependencia.label;
        }
        return acc;
      },
      {},
    );
    const copia_usuario = (formData.copia_usuario || []).reduce((acc, id) => {
      const copiaUsuario = listUsersCopiaDep.find((item) => item.value === id);
      if (copiaUsuario) {
        acc[id] = copiaUsuario.label;
      }
      return acc;
    }, {});

    let datos = {
      ...formData,
      copia_dependencia,
      copia_usuario,
    };

    try {
      const updateResponse = await fetch(
        process.env.REACT_APP_PUBLIC_URL + "radicacion/create",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            authorization: "Bearer " + sessionStorage.getItem("token"),
          },
          body: JSON.stringify(datos),
        },
      );
      const result = await updateResponse.json();
      showModalAlert("success", "Se creo correctamente la radicacion");
      loadRadicaciones();
    } catch (error) {
      console.error("No se creo correctamente", error);

      showModalAlert("danger", "Error al crear la radicacion");
    }
  }

  const consultarRegistro = async () => {
    const response = await fetch(
      process.env.REACT_APP_PUBLIC_URL + "radicacion/consult",
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      },
    );
  };

  const actionsList = [
    {
      title: "Imagen del radicado",
      ariaLabel: "view-image",
      icon: <PrintIcon />,
      onClick: async (row) => {
        console.log("roww..", row);
        setNumeroRadicado(row.numero_radicado);
        setFechaRadicado(row.fecha_radicacion);
        setUserResponsable(row.nombre_usuario);
        setFolios(row.numero_folios);
        setAnexos(row.numero_anexos);
        setDependenciaRes(row.nombre_dependencia);
        setRemitente(row.nombre_remitente);

        setTimeout(() => {
          handlePrint();
        }, 500);
      },
    },
    {
      title: "Subir documento",
      ariaLabel: "update-document",
      icon: <CloudUploadIcon />,
      onClick: async (row) => {
        setDocumentoSeleccionado(row);
        const idDoc = await loadDocumentosRadicados(row.id_gd_radicacion);
        setIdDocumentoRad(idDoc);
        handleOpenModal(row);
      },
      disabled: (row) => {
        return !!row.img_radicado;
      },
    },
    {
      title: "Ver documento",
      ariaLabel: "view-document",
      icon: <PictureAsPdfIcon />,
      onClick: async (row) => {
        setDocumentoSeleccionado(row);
        const idDoc = await loadDocumentosRadicados(row.id_gd_radicacion);
        setIdDocumentoRad(idDoc);
        setShowPdf(true);
      },
    },
  ];

  return (
    <>
      <GeneralTable
        title=""
        titleAlert="Radicación"
        buttonText="Crear Radicación"
        columns={columns}
        rows={radicaciones}
        modalFields={newModalField}
        initialFormData={{
          id_pais: 38,
          id_dep: 26,
        }}
        width={"70%"}
        enableView
        isModalRadication={true}
        formData={formData}
        setFormData={setFormData}
        onSaveModal={handleSaveRadication}
        requiredFields={requiredFields}
        actionsList={actionsList}
        rowCount={rowCount}
        pageSize={pageSize}
        page={page}
        handlePageChange={handlePageChange}
        handlePageSizeChange={handlePageSizeChange}
        loadRemitente={loadRemitente}
        isRadicacion={true}
        dates={dates}
        setDates={setDates}
        consultarRegistro={consultarRegistro}
      />
      {openModalSubir && (
        <SubirDocument
          openModal={openModalSubir}
          handleCloseModal={handleCloseModal}
          documentoSeleccionado={documentoSeleccionado}
          loadRadicaciones={loadRadicaciones}
        />
      )}

      <div style={{ display: "none", margin: "0mm", padding: "0mm", gap: 0 }}>
        <div
          ref={labelPrintRef}
          className="print-container"
          style={{
            width: "98mm",
            height: "23mm",
            display: "flex",
            flexDirection: "column",
            margin: "0mm",
            padding: "0mm",
            gap: 0,
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-evenly",
            }}
          >
            <div>
              <svg ref={barcodeRef}></svg>
              <div style={{ fontSize: 9, textAlign: "center" }}>
                Alcaldia de Pradera Valle
              </div>
            </div>
            <div style={{ fontSize: 9, width: "100%" }}>
              <b>Fecha:</b> {moment(fechaRadicado).format("YYYY-MM-DD HH:mm")}
              <br />
              <b>Radicador:</b> {userResponsable} <br />
              <b>Folios:</b> {folios} | <b>Anexos:</b> {anexos}
              <br />
              <b>Destino:</b> {dependenciaRes} <br />
              <b>Rem/Dest:</b> {remitente}
            </div>
          </div>
        </div>
      </div>

      {showPdf ? (
        <Modal
          open={showPdf}
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          style={{ zIndex: 1000 }}
        >
          <div
            className="paperAppointment-flex"
            style={{ width: "100%", margin: 10 }}
          >
            <IconButton
              style={{ float: "right" }}
              onClick={() => {
                setShowPdf(false);
              }}
            >
              <CloseIcon />
            </IconButton>
            <iframe
              id="pdfV"
              width="1000"
              height="700"
              src={
                process.env.REACT_APP_PUBLIC_URL +
                "documento-radicados/ver/" +
                idDocumentoRad +
                "/" +
                sessionStorage.getItem("token")
              }
            ></iframe>
          </div>
        </Modal>
      ) : null}
    </>
  );
}
